export const API_URLS = {
  billingEntitlements: "/api/billing/entitlements",
  accountPrivacy: "/api/account/privacy",
  accountAIConsent: "/api/account/ai-consent",
  accountDeletion: "/api/account/deletion",
  agentDreamStream: "/api/agent/dream-stream",
  agentDreamPlan: "/api/agent/dream-plan",
  agentClarifyQuestions: "/api/agent/clarify-questions",
  createCheckoutSession: "/api/stripe/payment/checkout",
  stripePortal: "/api/stripe/portal",
  dreamsFullCreate: "/api/dreams/full",
  trackFull: "/api/track/full",
  dashboardInsights: "/api/dashboard/insights",
  dashboardTimeline: "/api/dashboard/timeline",
  dashboardDreams: "/api/dashboard/dreams",
  settingsCategories: "/api/settings/categories",
  settingsNotificationPrefs: "/api/settings/notification-prefs",
  profileFields: "/api/profile/fields",
  profile: "/api/profile",
  milestoneBatchDate: "/api/milestones/batch-date",

  dream: (dreamId: string) => `/api/dreams/${dreamId}`,
  goals: (dreamId: string) => `/api/dreams/${dreamId}/goals`,
  goalsReorder: (dreamId: string) => `/api/dreams/${dreamId}/goals/reorder`,
  goal: (dreamId: string, goalId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}`,
  goalDuplicate: (dreamId: string, goalId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}/duplicate`,
  milestones: (dreamId: string, goalId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}/milestones`,
  milestonesReorder: (dreamId: string, goalId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}/milestones/reorder`,
  milestone: (dreamId: string, goalId: string, milestoneId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}/milestones/${milestoneId}`,
  milestoneDuplicate: (dreamId: string, goalId: string, milestoneId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}/milestones/${milestoneId}/duplicate`,
  milestoneNoteReveal: (dreamId: string, goalId: string, milestoneId: string, noteId: string) =>
    `/api/dreams/${dreamId}/goals/${goalId}/milestones/${milestoneId}/notes/${noteId}/reveal`,
};
